import { createSlice } from "@reduxjs/toolkit";
import { ORGANIZATION, TAB } from "../ultis";

const initialState = {
    tableData: {
        data: [],
        total: 1
    },
    searchQuery: {
        group: [1, 2],
        search: '',
        organization: ORGANIZATION.SYSTEM,
        status: ["status.active", "status.disable"],
        page: 0,
        textValue: ''
    },
    toggleRefresh: false,
    isCreate: false,
    isEdit: false,
    isSubmit: false,
    isFetchData: false,
    isUpdate: false,
    selectedIdItem: "",
    selectedItem: {},
    tabSelected: TAB.ROLE
}

export const managerRoleSlice = createSlice({
    name: 'managerrole',
    initialState,
    reducers: {
        setTableData: (state, action) => void (state.tableData = action.payload),
        setSearchQuery: (state, action) => void (state.searchQuery = action.payload),
        setToggleRefresh: (state, action) => void (state.toggleRefresh = action.payload),
        setIsCreate: (state, action) => void (state.isCreate = action.payload),
        setSelectedIdItem: (state, action) => void (state.selectedIdItem = action.payload),
        setSelectedItem: (state, action) => void (state.selectedItem = action.payload),
        setIsSubmit: (state, action) => void (state.isSubmit = action.payload),
        setIsFetchData: (state, action) => void (state.isFetchData = action.payload),
        setTabSelected: (state, action) => void (state.tabSelected = action.payload),
        setIsEdit: (state, action) => void (state.isEdit = action.payload),
        setIsUpdate: (state, action) => void (state.isUpdate = action.payload),
        setDefault: (state, action) => void (
            state.searchQuery.group = [1, 2],
            state.searchQuery.search = '',
            state.searchQuery.textValue = '',
            state.searchQuery.organization = ORGANIZATION.SYSTEM,
            state.searchQuery.status = ["status.active", "status.disable"],
            state.searchQuery.page = 0,
            state.tabSelected = TAB.ROLE
        )
    }
})

export const { setTableData, setSearchQuery, setIsCreate, setSelectedIdItem, setSelectedItem, setIsSubmit, setIsFetchData, setToggleRefresh, setTabSelected, setIsEdit, setIsUpdate, setDefault } = managerRoleSlice.actions
export default managerRoleSlice.reducer